/**
 * Bundle common js/vue components for home/landing page
 **/


import 'whatwg-fetch';
import 'babel-polyfill';
import { store } from './vuex-store.js';
import Vue2TouchEvents from 'vue2-touch-events';
import Vue from "vue";
import BasicSearch from "./components/header/BasicSearch.vue";
import KioskSearch from "./components/header/KioskSearch.vue";
import TheHeaderCartInfo from "./components/TheHeaderCartInfo.vue";
import ThePageFooter from "./components/ThePageFooter";
import TheHomePage from "./components/TheHomePage23";
import Notification from "./components/Notification";
import MtgCardImage from "./components/MtgSingle.vue";
import TheMegaMenu from "./components/megamenu/TheMegaMenu.vue";
import VueMeta from 'vue-meta'

window.Vue = require('vue');
Vue.use(Vue2TouchEvents,{
  disableClick: false,
  touchClass: '',
  tapTolerance: 10,
  touchHoldTolerance: 400,
  swipeTolerance: 50,
  longTapTimeInterval: 400,
  namespace: 'touch'
});
Vue.prototype.$isPortal = process.env.MIX_IS_PORTAL
Vue.prototype.$locationName = process.env.MIX_LOCATION_NAME || "Card Kingdom"
Vue.use(VueMeta)

// Initialize initial global components, to make available in root template
Vue.component('basic-search', BasicSearch);
Vue.component('kiosk-search', KioskSearch);
Vue.component('header-cart-info', TheHeaderCartInfo);
Vue.component('the-footer', ThePageFooter);
Vue.component('the-home-page', TheHomePage);
Vue.component('the-notification', Notification);
Vue.component('mtg-card-image', MtgCardImage);
Vue.component('the-mega-menu', TheMegaMenu);

Vue.filter('toCurrency', function (value) {
  if (typeof value !== "number") {
    return value;
  }
  var formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD'
  });
  return formatter.format(value);
});

//initialze vue
const app = new Vue({
  el: '#appWrapper',
  store,
  ck: ck || {},
});
